var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import proptypes from "prop-types";
import Typography from "../Typography";
import classNames from "classnames";
import Badge from "../Badge";
import Pill from "../Pill";
import useDidUpdateEffect from "../../hooks/useDidUpdateEffect";
var TabHead = function (_a) {
    var onClick = _a.onClick, isSelected = _a.isSelected, tabKey = _a.tabKey, name = _a.name, showDot = _a.showDot, pillLabel = _a.pillLabel;
    var handleTabHeaderClick = function () {
        onClick(tabKey);
    };
    var classnames = classNames({ "mex-tab__header": true, "mex-tab__header--selected": isSelected });
    return (_jsxs("div", __assign({ className: classnames, onClick: handleTabHeaderClick }, { children: [_jsx(Typography, __assign({ variant: isSelected ? "body01Semibold" : "body01Regular" }, { children: name })), showDot && _jsx(Badge, { className: "mex-tab__header-dot" }), pillLabel && _jsx(Pill, { className: "mex-tab__header-dot", label: pillLabel, variant: "alert", contrast: "high" })] })));
};
var TabBody = function (_a) {
    var rendered = _a.rendered, isSelected = _a.isSelected, children = _a.children;
    var classnames = classNames({ "mex-tab__panel": true, "mex-tab__panel--inactive": !isSelected });
    return _jsx("div", __assign({ className: classnames }, { children: rendered ? children : null }));
};
export var Tab = function (_a) {
    var tabs = _a.tabs, activeKey = _a.activeKey, defaultActiveKey = _a.defaultActiveKey, onChange = _a.onChange;
    var selectedKeyFromProp = activeKey ? activeKey : defaultActiveKey || tabs[0].key;
    var _b = useState(selectedKeyFromProp), selectedKey = _b[0], setSelectedKey = _b[1];
    var _c = useState(tabs.map(function (tab) { return (__assign(__assign({}, tab), { rendered: tab.key === selectedKey })); })), tabEls = _c[0], setTabEls = _c[1];
    useEffect(function () {
        if (activeKey) {
            setSelectedKey(activeKey);
            setTabEls(tabEls.map(function (tab) { return (tab.key === activeKey ? __assign(__assign({}, tab), { rendered: true }) : tab); }));
        }
    }, [activeKey]);
    // to add support for dynamic tabs. so it will update when the values of tab changes
    useEffect(function () {
        setTabEls(tabs.map(function (tab) { return (__assign(__assign({}, tab), { rendered: tab.key === selectedKey })); }));
    }, [tabs]);
    useDidUpdateEffect(function () {
        setTabEls(tabs.map(function (tab) { return (__assign(__assign({}, tab), { rendered: tab.key === selectedKey })); }));
    }, [tabs]);
    useDidUpdateEffect(function () {
        if (activeKey)
            onChange === null || onChange === void 0 ? void 0 : onChange(activeKey);
    }, [activeKey]);
    var handleTabHeaderClick = function (key) {
        setSelectedKey(key);
        setTabEls(tabEls.map(function (tab) { return (tab.key === key ? __assign(__assign({}, tab), { rendered: true }) : tab); }));
        onChange === null || onChange === void 0 ? void 0 : onChange(key);
    };
    var filterredTabs = tabEls.filter(function (tab) { return !tab.hide; });
    return (_jsxs("div", __assign({ className: "mex-tab" }, { children: [_jsx("div", __assign({ className: "mex-tab__headers" }, { children: filterredTabs.map(function (_a) {
                    var name = _a.name, key = _a.key, badge = _a.badge;
                    return (_jsx(TabHead, { name: name, tabKey: key, onClick: handleTabHeaderClick, isSelected: selectedKey === key, showDot: typeof badge === "boolean" && badge, pillLabel: typeof badge === "string" ? badge : "" }, key));
                }) })), _jsx("div", __assign({ className: "mex-tab__body", style: { marginLeft: "-".concat(filterredTabs.findIndex(function (tab) { return tab.key === selectedKey; }) * 100, "%") } }, { children: filterredTabs.map(function (_a) {
                    var children = _a.children, key = _a.key, rendered = _a.rendered;
                    return (_jsx(TabBody, __assign({ rendered: rendered, isSelected: selectedKey === key }, { children: children }), key));
                }) }))] })));
};
Tab.propTypes = {
    defaultActiveKey: proptypes.string,
    activeKey: proptypes.string,
    onChange: proptypes.func,
    tabs: proptypes.arrayOf(proptypes.shape({ key: proptypes.string, name: proptypes.string, children: proptypes.node }))
        .isRequired,
};
export default Tab;
